import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';

import types from './types';
import * as api from './api';
import {promiseAction, failAction, ActionError, failActionButPassMetrics} from '~/misc/dispatch';
import HTTPError from '~/misc/HTTPError';
import {prepare} from '~/misc/create';
import create from '~/misc/create';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';

import {getAccount, initAccountLevel, initAccountInfo} from '~/modules/account/actions';
import {initUserAccountInfo} from '~/modules/userAccountPage/actions';
import {initPlanInfo} from '~/modules/hp/actions';

import {regDot, regMc} from '~/misc/reg';
import {errorInfoConfig} from '~/misc/error-info';

import {checkLIneAlert, clearCheckInterval} from '~/modules/alert/actions';
import store from "~/store";
import {clearGlobalParams, updateGlobalParams} from "~/modules/window/actions";
import {push as changeURL} from 'react-router-redux';

import messagePush from '~/misc/messagePush';
import {getToken as getMessagePushToken} from '~/pages/MessagePush/state/action'
const messages = {
  wrongNewPassW: 'New password is empty or invalid',
  wrongId: 'User id does not match user token',
  wrongOldPassW: 'Current password is not correct!',
  emptyDot: errorInfoConfig.dot.empty,
  wrongDot: errorInfoConfig.dot.wrong,
  wrongEmail: 'Invalid email address',
  alreadyTaken: 'Email already registered. Try logging in with your Trucker Path mobile email and password',
  loginFailed: 'Incorrect email or password',
};

export const logOut = () => (dispatch) => {
  // 登出时，关闭定时器
  dispatch(clearGlobalParams());
  messagePush.close();
  clearCheckInterval();
  initAccountLevel(dispatch);
  initPlanInfo(dispatch);
  initAccountInfo(dispatch);
  initUserAccountInfo(dispatch);
  return dispatch({type: types.LOGOUT});
};

export const getSetAlert = () => (dispatch, getState) => {
  return promiseAction(
    dispatch,
    getState,
    types.USER_SET_ALERT_DEFLUAT,
    api.getSetAlertSetting(getState)
  )
}

export const getUserData = (dispatch, getState, token) => {
  // 获取用户信息时，开启定时器，不断获取alerts
  dispatch(checkLIneAlert());
  // user message push
  dispatch(getMessagePushToken(token));
  dispatch(getSetAlert())
  return promiseAction(dispatch, getState, types.USER_DATA, api.getUser(getState, token).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)};

export const getUserVerifyData = () => (dispatch, getState) => {
  const token = get(getState(), 'user.token');
  return promiseAction(dispatch, getState, types.USER_VERIFY, api.getW9form(getState, token).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}

export const getUserW9form = (id, token) => (dispatch, getState) => {
  return promiseAction(dispatch, getState, types.USER_W9FORM, api.getW9formInfo(getState, id, token).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}

export const uploadW9form = (id, token, file) => (dispatch, getState) => {
  return promiseAction(dispatch, getState, types.USER_UPLOAD_W9FORM, api.uploadW9form(getState, id, token, file).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}

export const uploadW9formByEmail= (token, file) => (dispatch, getState) => {
  return promiseAction(dispatch, getState, types.USER_UPLOAD_W9FORM, api.uploadW9formByEmail(getState, token, file).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}

export const uploadInfo = (id, token, files) => (dispatch, getState) => { 
  return promiseAction(dispatch, getState, types.USER_UPLOAD_INFO, api.uploadInfo(getState, id, token, files).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}


export const uploadInfoForLoadsmart = (id, token, files) => (dispatch, getState) => { 
  return promiseAction(dispatch, getState, types.USER_UPLOAD_INFO, api.uploadInfoForLoadsmart(getState, id, token, files).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}

export const getInfoForLoadsmart = (id, token, files) => (dispatch, getState) => { 
  return promiseAction(dispatch, getState, types.USER_UPLOAD_INFO, api.getInfoForLoadsmart(getState, id, token, files).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}

export const uploadInfoFromEmailByAnon = (token, files) => (dispatch, getState) => { 
  return promiseAction(dispatch, getState, types.USER_UPLOAD_INFO, api.uploadInfoFromEmailByAnon(getState, token, files).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}

export const uploadInfoFromEmail = (id, token, files) => (dispatch, getState) => { 
  return promiseAction(dispatch, getState, types.USER_UPLOAD_INFO, api.uploadInfoFromEmail(getState, id, token, files).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
)}


export const setTokenToUser = (token) => (dispatch) => dispatch(create(types.SET_TOKEN, {token: token}));

// 柯里化：接受参数，参数可以是数值，也可以是函数，返回接收余下参数的函数。
export const logIn = ({login, password, navigateUrl, nextAction}) => (dispatch, getState) =>
  promiseAction(dispatch, getState, types.LOGIN_FULL,
    promiseAction(dispatch, getState, types.LOGIN,
      api.logIn(getState, trim(login), trim(password))
        .catch(error => {
          if (error instanceof HTTPError && error.response.status === 403) {
            throw new ActionError(messages.loginFailed);
          }
          throw error;
        })
    )
    .then(user => getUserData(dispatch, getState, user.token))
    .then(() => getAccount(dispatch, getState))
  ).then(() => {
    if (!getState().user.emailVerified && getState().dots.mainSwitch.data.email_switch.switch) {
      dispatch(modalChange(modes.EMAIL_VALIDATE, {
        email: getState().user.email,
        type: 'askPop',
        source: 'sign-up-pop',
      }));
    }
    if(navigateUrl) {
      dispatch(changeURL(navigateUrl))
    }else {
      nextAction && nextAction();
    }
  })

export const initUser = () => (dispatch, getState) => {
  const token = get(getState(), 'user.token');
  return token
    ? promiseAction(dispatch, getState, types.USER_FROMSTORAGE, getUserData(dispatch, getState, token)
      .then(() => getAccount(dispatch, getState)))
    : null;
};

export const signUp = ({email, password, passwordAgain, dot, mc, nextAction}) => (dispatch, getState) => {
  const dotSwitch = getState().dots.data.dot_sign_switch;
  if (password !== passwordAgain) {
    return failAction(dispatch, types.SIGNUP, 'Passwords do not match');
  }
  if (!email || !password) {
    return failAction(dispatch, types.SIGNUP, 'Please fill out all fields');
  }
  if (!email.includes('@')) {
    return failAction(dispatch, types.SIGNUP, messages.wrongEmail);
  }
  if (Boolean(dotSwitch) && !dot && !mc) {
    return failAction(dispatch, types.SIGNUP, messages.emptyDot);
  }
  if (Boolean(dotSwitch) && dot) {
    if (!regDot.test(dot)) {
      return failAction(dispatch, types.SIGNUP, messages.wrongDot);
    }
  }
  if (Boolean(dotSwitch) && mc) {
    if (!regMc.test(mc)) {
      return failAction(dispatch, types.SIGNUP, messages.wrongDot);
    }
  }

  return promiseAction(dispatch, getState, types.SIGNUP_FULL,
    promiseAction(dispatch, getState, types.SIGNUP,
      api.signUp(getState, trim(email), trim(password), trim(dot), trim(mc)).catch(error => {
        if (!(error instanceof HTTPError)) {
          throw error;
        }
        
        return error.responsePromise.then(body => {
          const e = get(body, 'api_errors', [])[0] || {};
          if (e.type === 'bad_argument' && e.value === 'email') {
            throw new ActionError(messages.wrongEmail);
          }
          if (e.type === 'bad_param' && e.value === 'dot_unavailable') {
            throw new ActionError(messages.wrongDot);
          }
          if (e.type === 'bad_param' && e.value === 'mc_unavailable') {
            throw new ActionError(messages.wrongDot);
          }
          if (e.type === 'signup' && e.value === 'email_taken') {
            throw new ActionError(messages.alreadyTaken);
          }
          throw error;
        });
      })
    )
      .then(user => getUserData(dispatch, getState, user.token))
      .then(() => getAccount(dispatch, getState))
  )
  .then(() => {
    if (!getState().user.emailVerified && getState().dots.mainSwitch.data.email_switch.switch) {
      dispatch(
        modalChange(modes.EMAIL_VALIDATE, {email: getState().user.email, type: 'tipsPop', source: 'sign-up-pop'})
      );
    }
  }).then(() => {
    nextAction && nextAction();
  })
};
export const signUpV2 = (data) => (dispatch, getState) => {
  const {email, password, firstName, lastName, phone, type, authNumber, source} = data;
  const errorChecker = (data) => {
    const {email, password, firstName, lastName, phone, type, authNumber, source} = data;
    let errors = {
      account_required_error: false,
      password_required_error: false,
      firstName_required_error: false,
      lastName_required_error: false,
      phone_required_error: false,
      authNumber_required_error: false,
      password_format_error: false,
      phone_format_error: false,
      email_format_error: false,
      authNumber_format_error: false,
      all_required_error: false,
    };
    let message = '';
    if (type === 'us' && (authNumber.length > 7 || authNumber.length < 5)) {
      errors.authNumber_format_error = true;
      message = 'Not a valid DOT/MC';
    }
    if (type === 'mc' && authNumber.length !== 6) {
      errors.authNumber_format_error = true;
      message = 'Not a valid DOT/MC';
    }
    if (!new RegExp(/^([\w-_]+(?:\.[\w-_]+)*)@((?:[a-z0-9]+(?:-[a-zA-Z0-9]+)*)+\.[a-z]{2,6})$/i).test(email)) {
      errors.email_format_error = true;
      message = 'Enter email in user@example.com format';
    }
    if (password.length < 4) {
      errors.password_format_error = true;
      message = 'Please enter a password with at least 4 characters ';
    }
    if (phone.length !== 10) {
      errors.phone_format_error = true;
      message = 'Please enter a 10 digits phone number';
    }
    if (!authNumber) {
      errors.authNumber_required_error = true;
      message = 'Authority number is required';
    }
    if (!phone) {
      errors.phone_required_error = true;
      message = 'Please enter a 10 digits phone number';
    }
    if (!lastName) {
      errors.lastName_required_error = true;
      message = 'Last name is required';
    }
    if (!firstName) {
      errors.firstName_required_error = true;
      message = 'First name is required';
    }
    if (!password) {
      errors.password_required_error = true;
      message = 'Password is required';
    }
    if (!email) {
      errors.account_required_error = true;
      message = 'Account email is required';
    }
    if (errors.account_required_error && errors.password_required_error && errors.firstName_required_error && errors.lastName_required_error && errors.phone_required_error && errors.authNumber_required_error) {
      errors.all_required_error = true;
    }
    return {errors, message};
  };

  const {errors, message} = errorChecker(data);
  if (message !== '') {
    return failActionButPassMetrics(dispatch, types.SIGNUPV2, message, errors);
  }
  return promiseAction(dispatch, getState, types.SIGNUP_FULL,
    promiseAction(dispatch, getState, types.SIGNUPV2,
      api.signUpV2(getState, trim(email), trim(password), trim(firstName), trim(lastName), trim(phone), trim(type), trim(authNumber), trim(source))
      .catch(error => {
        if (!(error instanceof HTTPError)) {
          throw error;
        }
        return error.response.json().then(body => {
          const e = get(body, 'message', 'some Errors')
          throw new ActionError(e);
        });
      })
    )
      .then(user => getUserData(dispatch, getState, user.token))
      .then(() => getAccount(dispatch, getState))
  )
  .then(() => {
    if (!getState().user.emailVerified && getState().dots.mainSwitch.data.email_switch.switch) {
      dispatch(
        modalChange(modes.EMAIL_VALIDATE, {email: getState().user.email, type: 'tipsPop', source: 'sign-up-pop'})
      );
    }
  });
};

export const signUpInWelcome = ({
  email,
  firstName,
  lastName,
  phone,
  dot,
  mc,
  companyName,
  password}) => (dispatch, getState) => {
    return promiseAction (dispatch, getState, types.SIGNUP, 
      api.signUpInWelcome(getState, {
        email,
        firstName,
        lastName,
        phone,
        dot,
        mc,
        companyName,
        password
      }).catch(error => {
        if (!(error instanceof HTTPError)) {
          throw error;
        }
        return error.response.json().then(body => {
          const e = get(body, 'message', 'some Errors')
          throw new ActionError(e);
        });
      })
    )
    .then(user => getUserData(dispatch, getState, user.token))
    .then(() => getAccount(dispatch, getState))
  }

export const resetPassword = (email) => (dispatch, getState) => {
  if (isEmpty(email) || !email.includes('@')) {
    return failAction(dispatch, types.RESET_PASSWORD, messages.wrongEmail);
  }

  return promiseAction(dispatch, getState, types.RESET_PASSWORD,
    api.resetPassword(getState, email).catch(error => {
      const status = error.response.status;
      if (status === 404 || status === 400) {
        throw new ActionError(messages.wrongEmail);
      }
      throw error;
    })
  );
};

export const changePassword = (dispatch, getState, val) => promiseAction(dispatch, getState, types.CHANGE_PASSWORD,
  api.changePassword(getState, val).catch(error => {
    const status = error.response.status;
    if (status === 404) {
      throw new ActionError(messages.wrongId);
    } else if (status === 403) {
      throw new ActionError(messages.wrongOldPassW);
    } else if (status === 400) {
      throw new ActionError(messages.wrongNewPassW);
    }
    throw error;
  })
);

export const updateUser = (id, data) => (dispatch, getState) =>
  promiseAction(dispatch, getState, types.USER_UPDATED, api.patchUser(getState, id, data));

export const hideChangePasswordAsyncErrorMessage = (dispatch, val) =>
  dispatch(create(types.CHANGE_PASSWORD_ASYNG_ERROR_HIDE, val));


export const reportJobTitle = prepare(types.USER_REPORTED_JOBTILE);

export const getW9fromInfoByEmail = (token) =>  (dispatch, getState) =>
  promiseAction(dispatch, getState, types.GET_W9FORM_BY_EMAIL, api.getW9fromInfoByEmail(getState, token));

export const getDotMc = ({dot, mc}) => (dispatch, getState) => 
promiseAction(dispatch, getState, types.GET_DOTMC, api.getDotMc(getState, {dot, mc}));


export const setAlert = (flag) => (dispatch, getState) => {
  dispatch(create(types.USER_SET_ALERT, flag))
  return promiseAction(
    dispatch, 
    getState,
    types.USER_UPDATE_ALERT, 
    api.setSetAlert(getState, flag)
  );
}
  ;

export const setAlertPop = () => (dispatch, getState) =>{
  dispatch(create(types.USER_SET_ALERT_POP));
  return promiseAction(
    dispatch, 
    getState,
    types.USER_UPDATE_ALERT_POP, 
    api.setSetAlertPoped(getState, true)
  );
} 




// WEBPACK FOOTER //
// ./src/modules/user/actions.js